/* eslint-disable react/no-deprecated */
/* eslint-disable react/react-in-jsx-scope */
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "bootstrap";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/elegant-icons/style.css";
import "../node_modules/et-line/style.css";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import "../node_modules/react-datetime/css/react-datetime.css";
import App from "./App";
import config from "./config";
import { I18nLoader } from "./i18n";
import * as serviceWorker from "./serviceWorker";
import { store } from "./store";
import "./assets/style.scss";
import "./assets/scss/hybrid-pages.scss";
import "./assets/scss/hybrid.scss";

// Dynamically import the CSS file at initial load
//here will be replaced to detect whether user is using web,iphone or android
//and import different root.module.css and style.scss

window.addEventListener("DOMContentLoaded", () => {
	import(`./components/client/${config.client}/root.module.css`)
		.then(() => {
			console.log("CSS loaded successfully!");
		})
		.catch((err) => {
			console.error("Error loading CSS:", err);
		});

	import(`./components/client/${config.client}/custom.scss`)
		.then(() => {
			console.log("SCSS loaded successfully!");
		})
		.catch((err) => {
			console.error("Error loading SCSS:", err);
		});
});

ReactDOM.render(
	<I18nLoader>
		<Provider store={store}>
			<App />
		</Provider>
	</I18nLoader>,
	document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
